export const permissionsRoute = [
  {
    permission: 'view_das',
    route: '/',
    routeName: 'home'
  },
  {
    permission: 'view_per',
    route: '/profile',
    routeName: 'profile'
  },
  {
    permission: 'view_emp',
    route: '/company',
    routeName: 'company'
  },
  {
    permission: 'view_epi',
    route: '/new-request',
    routeName: 'new-request'
  },
  {
    permission: 'view_est',
    route: '/stock',
    routeName: 'stock'
  },
  {
    permission: 'add_est',
    route: '/stock/new',
    routeName: 'stock-new'
  },
  {
    permission: 'view_fun',
    route: '/employees',
    routeName: 'employees'
  },
  {
    permission: 'edit_fun',
    route: '/employees/new',
    routeName: 'employees-new'
  },
  {
    permission: 'view_tre',
    route: '/trainings',
    routeName: 'training'
  },
  {
    permission: 'view_aso',
    route: '/asos',
    routeName: 'asos'
  },
  {
    permission: 'view_ext',
    route: '/extinguisher',
    routeName: 'extin'
  },
  {
    permission: 'view_col',
    route: '/collab',
    routeName: 'collaborators'
  },
  {
    permission: 'add_col',
    route: '/collab/new',
    routeName: 'new-collab'
  },
  {
    permission: '',
    route: '/error',
    routeName: 'page-error'
  }
]
